<template>
  <div class="card payment">
    <div class="card-body">
      <div class="d-flex align-items-center">
        <h1 class="h2 mb-0">Способы оплаты</h1>
      </div>
      <div class="payment-block text-start">
        <p>Минимальная сумма оплаты — 1 рубль.</p>
        <span>
          К оплате принимаются банковские карты, у которых 16, 18, 19 цифр в номере:
          <ul>
            <li>VISA, MasterCard, МИР, China UnionPay, JCB и American Express;</li>
            <li>VISA Electron/Plus, Cirrus/Maestro, если у них есть код CVC2 и CVV2;</li>
          </ul>
        </span>
        <p>После оплаты заказа вы получите электронный чек на почту.</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  @import '@/assets/styles/PaymentInfo';
</style>
